// WebAudio with mobile autoplay unlock (must be called once inside a user tap)
const ac = () => window.__giss_ac || (window.__giss_ac = new (window.AudioContext || window.webkitAudioContext)());

export function unlockAudio() {
  try {
    const A = ac();
    A.resume?.();
    const s = A.createBufferSource();
    s.buffer = A.createBuffer(1, 1, 22050);
    s.connect(A.destination);
    s.start(0);
  } catch { /* no audio */ }
}

export const audioReady = () => window.__giss_ac?.state === 'running';

export function beep(f1, f2) {
  try {
    const A = ac();
    if (A.state !== 'running') A.resume?.();
    [f1, f2].forEach((f, i) => { const o = A.createOscillator(), g = A.createGain(); o.frequency.value = f; g.gain.value = 0.2; o.connect(g).connect(A.destination); o.start(A.currentTime + i * 0.18); o.stop(A.currentTime + i * 0.18 + 0.15); });
  } catch { /* no audio */ }
  navigator.vibrate?.(f1 < f2 ? 80 : [200, 80, 200]);
}
